import React from 'react';
import './Footer.css';
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
// eslint-disable-next-line
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t, i18n } = useTranslation();
    if(window.location.href==="https://jsource.sy/"){
        return (
            <footer id="footer">
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 footer-contact">
                                <h3>JSOURCE</h3>
                                <p>{t('Damascus')}</p>
                                <p>{t('Victoria_Bridge')} </p>
                                <p>{t('Syria')}Syria</p>
                                <p><strong>{t('Phone')}:</strong><span dir='ltr'> 011 233 66 55</span>  </p>
                                <p><strong>{t('Email')}:</strong> jsource2022@gmail.com</p>
                            </div>
                            <div className="col-lg-3 col-md-6 footer-links">
                                <h4>{t('Useful_Links')}</h4>
                                <ul>
                                    <li><i className="bi bi-chevron-double-right"></i> <a href="#hero">{t('Home')}</a></li>
                                    <li><i className="bi bi-chevron-double-right"></i> <a href="#services">{t('Services')}</a></li>
                                    <li><i className="bi bi-chevron-double-right"></i> <a href="#customers">{t('Customers')}</a></li>
                                    <li><i className="bi bi-chevron-double-right"></i> <a href="#about">{t('About')}</a></li>
                                </ul>
                            </div>
                            <div className="col-lg-4 col-md-6 footer-links">
                                <h4>{t('Our_Projects')}</h4>
                                <ul>
                                    <li><i className="bi bi-chevron-double-right"></i><NavLink   to="/Alm7seb">{t('Alm7seb')}</NavLink ></li>
                                    <li><i className="bi bi-chevron-double-right"></i><NavLink   to="/Resturant">{t('MyRestaurants')}</NavLink ></li>
                                    <li><i className="bi bi-chevron-double-right"></i> <NavLink   to="/Resturant">{t('Hotel')}</NavLink ></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div dir='ltr' className="container d-md-flex py-4">
                    <div className="me-md-auto text-center text-md-start">
                        <div className="copyright">
                            &copy; Copyright <strong><span>jsource</span></strong>. All Rights Reserved
                        </div>
                    </div>
                </div>
            </footer>                        
        )
    }else{

        return (
            <footer id="footer">
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 footer-contact">
                                <h3>JSOURCE</h3>
                                <p>{t('Damascus')}</p>
                                <p>{t('Victoria_Bridge')} </p>
                                <p>{t('Syria')}Syria</p>
                                <p><strong>{t('Phone')}:</strong><span dir='ltr'> 011 233 66 55</span>  </p>
                                <p><strong>{t('Email')}:</strong> jsource2022@gmail.com</p>
                            </div>
                            <div className="col-lg-3 col-md-6 footer-links">
                                <h4>{t('Useful_Links')}</h4>
                                <ul>
                                    <li><i className="bi bi-chevron-double-right"></i><NavLink   to="/">{t('Home')}</NavLink></li>
                                    <li><i className="bi bi-chevron-double-right"></i><NavLink   to="/">{t('Services')}</NavLink></li>
                                    <li><i className="bi bi-chevron-double-right"></i><NavLink   to="/">{t('Customers')}</NavLink></li>
                                    <li><i className="bi bi-chevron-double-right"></i><NavLink   to="/">{t('About')}</NavLink></li>
                                </ul>
                            </div>
                            <div className="col-lg-4 col-md-6 footer-links">
                                <h4>{t('Our_Projects')}</h4>
                                <ul>
                                    <li><i className="bi bi-chevron-double-right"></i> <NavLink   to="/Alm7seb">{t('Alm7seb')}</NavLink ></li>
                                    <li><i className="bi bi-chevron-double-right"></i> <NavLink   to="/Resturant">{t('MyRestaurants')}</NavLink ></li>
                                    <li><i className="bi bi-chevron-double-right"></i><NavLink   to="/Resturant">{t('Hotel')}</NavLink ></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div dir='ltr' className="container d-md-flex py-4">
                    <div className="me-md-auto text-center text-md-start">
                        <div className="copyright">
                            &copy; Copyright <strong><span>jsource</span></strong>. All Rights Reserved
                        </div>
                    </div>
                </div>
            </footer>                        
        )


    }
    
}

export default Footer
